import { render } from "./referral-table.vue?vue&type=template&id=10e5c05d"
import script from "./referral-table.vue?vue&type=script&lang=js"
export * from "./referral-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__